import { forwardRef } from 'react';
import { cn } from '../lib/utils';

/**
 * @param {{ className?: string, dataTestId?: string } & React.InputHTMLAttributes<HTMLInputElement>} props
 */
const Input = forwardRef(function Input({ className, type, dataTestId, ...props }, ref) {
  return (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      data-testid={dataTestId}
      className={cn(
        'file:text-foreground placeholder:text-fg-placeholder selection:bg-primary selection:text-primary-foreground border-input flex h-9 w-full min-w-0 rounded-lg border px-3 py-1 text-base bg-input-background transition-[color,box-shadow] file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        'aria-invalid:border-destructive',
        className
      )}
      {...props}
    />
  );
});

export { Input };
